export default __webpack_public_path__ + "static/public_preposition_02_720p-d92ee22351c884ac93ec01f10ebd7445.jpg";